import { FC } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import RhfCheckboxGroup from 'components/CheckboxGroup/RhfCheckboxGroup/RhfCheckboxGroup';
import { RHFTextArea } from 'components/RHFTextArea/RHFTextArea';
import { OTHER } from 'constants/prescriptionConstants';
import { OVERBITE_CORRECT_OPEN_BITE } from 'constants/prescriptionOptions';
import { translate } from 'utils';
import { RemoveCheckedOptions } from 'utils/patientpageUtils';
import { isOtherOptionSelected } from 'utils/ultraPrescription.utils';

interface Props {
  isDisabled?: boolean;
}
const CorrectOpenBite: FC<Props> = ({ isDisabled }) => {
  const { watch, control } = useFormContext();
  const watchCorrectOpenBiteUpper = watch(
    'treatmentSpecifications.ZenClearUltra.overbite.correctOpenBite.Upper.upper'
  );
  const watchCorrectOpenBiteLower = watch(
    'treatmentSpecifications.ZenClearUltra.overbite.correctOpenBite.Lower.lower'
  );
  return (
    <div>
      <div className='flex flex-row space-x-4 mb-2'>
        <div className='mt-3 bg-black text-white flex justify-center items-center  w-6 h-6 rounded-full'>
          <span>U</span>
        </div>
        <Controller
          control={control}
          name={
            'treatmentSpecifications.ZenClearUltra.overbite.correctOpenBite.Upper.upper'
          }
          render={({ field }) => (
            <div className='w-full'>
              <RhfCheckboxGroup
                disabled={isDisabled}
                options={OVERBITE_CORRECT_OPEN_BITE}
                name='treatmentSpecifications.ZenClearUltra.overbite.correctOpenBite.Upper.upper'
                className='mt-1'
                checkBoxItemFont='md:text-17px text-sm flex flex-row space-x-10'
                onChange={(data, name, e) => {
                  field.onChange(RemoveCheckedOptions(data, OTHER, e));
                }}
              />
              {isOtherOptionSelected(watchCorrectOpenBiteUpper) && (
                <div className='my-5'>
                  <RHFTextArea
                    name={
                      'treatmentSpecifications.ZenClearUltra.overbite.correctOpenBite.Upper.upperOtherText'
                    }
                    autogrow
                    inputProps={{
                      disabled: isDisabled,
                      placeholder: translate('settings.please_type_here')
                    }}
                    maxgrowHeight={260}
                  />
                </div>
              )}
            </div>
          )}
        />
      </div>
      <div className='flex flex-row space-x-4'>
        <div className='mt-3 bg-black text-white flex justify-center items-center  w-6 h-6 rounded-full'>
          <span>L</span>
        </div>
        <Controller
          control={control}
          name={
            'treatmentSpecifications.ZenClearUltra.overbite.correctOpenBite.Lower.lower'
          }
          render={({ field }) => (
            <div className='w-full'>
              <RhfCheckboxGroup
                disabled={isDisabled}
                options={OVERBITE_CORRECT_OPEN_BITE}
                name='treatmentSpecifications.ZenClearUltra.overbite.correctOpenBite.Lower.lower'
                className='mt-1'
                checkBoxItemFont='md:text-17px text-sm flex flex-row space-x-10'
                onChange={(data, name, e) => {
                  field.onChange(RemoveCheckedOptions(data, OTHER, e));
                }}
              />
              {isOtherOptionSelected(watchCorrectOpenBiteLower) && (
                <div className='mt-5'>
                  <RHFTextArea
                    name={
                      'treatmentSpecifications.ZenClearUltra.overbite.correctOpenBite.Lower.lowerOtherText'
                    }
                    autogrow
                    inputProps={{
                      disabled: isDisabled,
                      placeholder: translate('settings.please_type_here')
                    }}
                    maxgrowHeight={260}
                  />
                </div>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};
export default CorrectOpenBite;
